<kendo-dialog *ngIf="dialogOpened" (close)="close($event);" [width]="500">
    <kendo-dialog-titlebar>
        <h3>{{ 'CHANGE-PASSWORD' | translate}}</h3>
    </kendo-dialog-titlebar>
    <div class="mt-2">
        <div class="row">
            <div class="col-1">
                <i class="fas icon-warn" [ngClass]="{'fa-exclamation-triangle': (expireDays >= 1), 
                'fa-times-circle': (expireDays < 1)}"></i>
            </div>
            <div class="col-11 pl-2">
                <span *ngIf="expireDays >= 1"
                    class="k-text-uppercase icon-warn text-center warn-modal-text">{{daysText.replace('{{days}}',
                    'DAYS-NUMBER' | pluralDays: expireDays | translate: { days: expireDays})}}</span>
                <span *ngIf="expireDays < 1"
                    class="k-text-uppercase icon-warn text-center warn-modal-text">{{'CHANGE-PASSWORD-EXPIRED' |
                    translate }}</span>
            </div>
        </div>
    </div>
    <form *ngIf="changePasswordForm" [formGroup]="changePasswordForm" class="k-form"
        style="margin-bottom:-10px!important">
        <div class="row">
            <div class="col w-100">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'PASSWORD' | translate}} *
                    </span>
                    <!--username is to prevent Chrome warning-->
                    <input type="text" name="username" autocomplete="username" class="d-none" />
                    <input id="password" type="password" kendoTextBox formControlName="password"
                        maxlength="{{maxPasswordLength}}" autocomplete="new-password" #passwordControl />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!closing && password.hasError('required') && (password.dirty || password.touched)">
                        {{'REQUIRED-PASSWORD' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!closing && password.hasError('pattern') && !password.hasError('minlength') && (password.dirty || password.touched)">
                        {{invalidPasswordText}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!closing && password.hasError('minlength') && (password.dirty || password.touched)">
                        <span translate [translateParams]="{value: minPasswordLength}">{{'PASSWORD-MIN-LENGTH'}}</span>
                    </div>
                    <password-strength-meter *ngIf="password.value" [password]="password.value"
                        [colors]="passwordMeterColors">
                    </password-strength-meter>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col w-100">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'PASSWORD-CONFIRM' | translate}} *
                    </span>
                    <input id="passwordConfirm" type="password" kendoTextBox formControlName="passwordConfirm"
                        maxlength="{{maxPasswordLength}}" autocomplete="new-password" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!closing && passwordConfirm.hasError('required') && (passwordConfirm.dirty || passwordConfirm.touched)">
                        {{'REQUIRED-CONFIRM-PASSWORD' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="!closing && passwordConfirm.hasError('unmatchConfirmPassword') && (passwordConfirm.dirty || passwordConfirm.touched)">
                        {{'CONFIRM-PASSWORD-NOT-MATCH' | translate}}
                    </div>
                </label>
            </div>
        </div>
    </form>
    <kendo-dialog-actions>
        <button kendoButton #closeButton (click)="close($event)" [disabled]="updating">{{ 'CANCEL' | translate }}
        </button>
        <button kendoButton (click)="savePassword()" [disabled]="!formValid() || !formDirty() || updating">{{
            'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>